module.exports = {
  path: '/',
  title: 'DataBackfill | Forward Deployed Engineers for Agentic Systems',
  description: 'DataBackfill sends forward deployed engineers who embed with your team, build in your stack, and ship agentic systems into your production. Fixed fee.',
};
